module.exports = __webpack_public_path__ + "static/img/winter_banner.9d5b7672.jpg";